import { useEffect, useRef } from "react";
import { Truck } from "../interface/api/Truck";
import truckService from "../services/truckService";

// Wait for typing to settle so a truck # like "102" is one lookup, not three.
const LOOKUP_DELAY_MS = 400;

/**
 * Looks up the registered truck once both the hauler and truck # are filled in, and hands
 * it to onFound so the form can fill the plate and driver. Only the latest pair is
 * answered: a response for a hauler/number the user has since changed is dropped.
 */
export const useTruckNumberAutofill = (
  haulerName: string | null | undefined,
  truckNumber: string | null | undefined,
  onFound: (truck: Truck) => void,
  enabled = true
) => {
  const onFoundRef = useRef(onFound);
  onFoundRef.current = onFound;

  useEffect(() => {
    const hauler = haulerName?.trim();
    const number = truckNumber?.trim();
    if (!enabled || !hauler || !number) return;

    let stale = false;
    const timer = setTimeout(() => {
      truckService.findTruck(hauler, number).then((response) => {
        if (!stale && response.ok && response.data) {
          onFoundRef.current(response.data as Truck);
        }
      });
    }, LOOKUP_DELAY_MS);

    return () => {
      stale = true;
      clearTimeout(timer);
    };
  }, [haulerName, truckNumber, enabled]);
};
